import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { RatesExplorer } from "@/pages/Rates";
import { PublicShell } from "@/components/PublicShell";
import { CALL_DESTINATIONS } from "@/data/callDestinations";

export default function PublicRates() {
  useEffect(() => {
    document.title = "International Calling Rates to 200+ Countries | ZEEPTEL";
    const m = document.querySelector('meta[name="description"]');
    const prev = m?.getAttribute("content");
    m?.setAttribute(
      "content",
      "See ZEEPTEL's per-minute rates for cheap international calls to Uganda, Kenya, Nigeria and 185+ countries. Prepaid credit that never expires — the person you call needs no internet or app."
    );
    return () => {
      document.title = "ZEEPTEL — Global Calling Credit";
      if (m && prev) m.setAttribute("content", prev);
    };
  }, []);

  return (
    <PublicShell>
      <main className="flex-1 w-full max-w-3xl mx-auto px-4 sm:px-6 pt-10 pb-16">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
          International calling rates
        </h1>
        <p className="mt-2 text-slate-500">
          Transparent per-minute pricing to 185+ countries. Prepaid credit that never expires — and the person you
          call needs no internet, no app, just their normal phone.
        </p>

        <RatesExplorer />

        <h2 className="mt-8 font-heading text-sm font-bold uppercase tracking-widest text-slate-400">Popular destinations</h2>
        <div className="mt-3 flex flex-wrap gap-2" data-testid="popular-destinations">
          {CALL_DESTINATIONS.map((d) => (
            <Link key={d.slug} to={`/call-${d.slug}`} className="px-3 py-1.5 rounded-full bg-white border border-slate-200 text-xs font-semibold text-slate-600 hover:border-[#2563EB] hover:text-[#2563EB] transition-colors">
              {d.flag} Call {d.country}
            </Link>
          ))}
        </div>

        <div className="mt-8 bg-[#1E3A8A] text-white rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-testid="public-rates-cta">
          <div>
            <div className="font-heading font-bold text-lg">Ready to call for less?</div>
            <div className="text-blue-200 text-sm">Create a free account, add credit and start calling in under a minute.</div>
          </div>
          <Link to="/register" data-testid="public-rates-cta-btn" className="inline-flex items-center gap-2 px-6 py-3 rounded-2xl bg-white text-[#1E3A8A] font-bold text-sm hover:bg-blue-50 transition-colors shrink-0">
            <Phone className="h-4 w-4" /> Start Calling <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </main>
    </PublicShell>
  );
}
